import { useContext } from 'react';
import { GlobalContext } from './context/GlobalContext';
import Page from './pages/Page';
import './App.scss';

function App() {
  const { state }: any = useContext(GlobalContext);
  let { rtl } = state;

    return (
      <Page rtl={rtl} />
    )
}

export default App;